import api from '@/api'

function hasProp(obj, prop) {
	return Object.prototype.hasOwnProperty.call(obj, prop)
}

export default {
	namespaced: true,

	state: {
		collection: [],
		currentTag: {},
	},

	getters: {
		//
	},

	mutations: {
		setCollection(state, collection) {
			state.collection = collection
		},

		pushToCollection(state, item) {
			state.collection.push(item)
		},

		setCurrentTag(state, tag) {
			state.currentTag = Object.assign({}, tag)
		},
	},

	actions: {
		list({ commit, state }) {
			api()
				.get('/tags/flat')
				.then((response) => {
					const tags = response.data.data.tag
					commit('setCollection', tags)
				})
				.catch((error) => {
					const tags = error.response.data.data.tag
					if (tags) {
						commit('setCollection', tags)
					}
				})
		},

		listDocumentTags({ commit, rootState }) {
			api()
				.get(`${rootState.documents.apiEndpoint}/tags`)

				.then((response) => {
					const tags = response.data.data.tag
					commit('setCollection', tags)
				})
				.catch((error) => {
					const tags = error.response.data.data.tag
					if (tags) {
						commit('setCollection', tags)
					}
				})
		},

		add({ commit, state }, tagName) {
			const tag = {
				id: tagName,
				name: tagName,
			}

			commit('pushToCollection', tag)
		},

		createDocumentTag({ state, dispatch, rootState }, tag = null) {
			const tagData = tag ? tag : state.currentTag
			return new Promise((resolve, reject) => {
				api()
					.put(`${rootState.documents.apiEndpoint}/tag`, { tag: tagData })
					.then((response) => {
						const category = response.data.data.tag[0]
						dispatch('listDocumentTags')
						resolve(response.data)
						// Send notification
						dispatch(
							'notifications/create',
							{
								body: `The tag <b>${category.name}</b> was created`,
								type: 'success',
							},
							{ root: true }
						)
					})
					.catch((error) => {
						if (
							error.response &&
							hasProp(error.response.data.meta, 'duplicate_tag')
						) {
							const duplicateTag = error.response.data.meta.duplicate_tag
							dispatch(
								'notifications/create',
								{
									title: 'Error!',
									body: `A tag with the name <b>${duplicateTag.name}</b> already exists`,
									type: 'danger',
									timeout: 12000,
								},
								{ root: true }
							)
						}
						reject(error.response.data)
					})
			})
		},

		updateDocumentTag({ state, dispatch, rootState }, tagId) {
			const tag = state.currentTag
			return new Promise((resolve, reject) => {
				api()
					.put(`${rootState.documents.apiEndpoint}/tag/${tagId}`, {
						tag,
					})
					.then((response) => {
						dispatch('listDocumentTags')
						const category = response.data.data.tag[0]
						resolve(response.data.data)
						// Send notification
						dispatch(
							'notifications/create',
							{
								body: `The tag <b>${category.name}</b> was updated`,
								type: 'success',
							},
							{ root: true }
						)
					})
					.catch((error) => {
						reject(error.response.data)
					})
			})
		},

		deleteDocumentTag({ dispatch, rootState }, tagId) {
			return new Promise((resolve, reject) => {
				api()
					.delete(`${rootState.documents.apiEndpoint}/tag/${tagId}`)
					.then((response) => {
						dispatch('listDocumentTags')
						// resolve(response.data.data);
						// Send notification
						dispatch(
							'notifications/create',
							{
								body: 'The tag was deleted',
								type: 'success',
							},
							{ root: true }
						)
					})
					.catch((error) => {
						reject(error.response.data)
					})
			})
		},

		readDocumentTag({ commit, state, rootState }, tagId) {
			commit('setCurrentTag', {})

			return new Promise((resolve, reject) => {
				api()
					.get(`${rootState.documents.apiEndpoint}/tag/${tagId}`)
					.then((response) => {
						commit('setCurrentTag', response.data.data.tag[0])
						resolve()
					})
					.catch((error) => {
						if (error.response && hasProp(error.response.data.data, 'tag')) {
							commit('setCurrentTag', error.response.data.data.tag[0])
						} else {
							reject(error.response)
						}
					})
			})
		},
	},
}
